export default __webpack_public_path__ + "static/media/blog-3.de57f6eb.webp";